import React from 'react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
} from '@chatscope/chat-ui-kit-react';
import { marked } from 'marked';

interface IChatProps {
    messages: any;
    isTyping: any;
    statusText: string;
    currentStreamingMessage: string;
    handleSendClick: any;
  };

const Chat2: React.FC<IChatProps> = (props: IChatProps) => {
  const { messages, currentStreamingMessage, isTyping, statusText, handleSendClick } = props;
  const cur_markup = marked(currentStreamingMessage, { breaks: true });

  return (
    <div style={{ position: 'relative', height: '60vh' }}>
      <MainContainer>
        <ChatContainer>
          <MessageList
            scrollBehavior='smooth'
            typingIndicator={isTyping ? <TypingIndicator content={statusText} /> : null}
          >
            <>
              {messages.map((message: any, i: number) => {
                let markup = '';
                if (message.message.value) {
                  markup = marked(message.message.value, { breaks: true });
                }else{
                  markup = marked(message.message, { breaks: true });
                }
                return <Message key={i} model={{
                  type: 'html',
                  payload: markup,
                  direction: message.direction,
                  sender: message.sender,
                  position: 0,
                }}
                />;
              })}
              {currentStreamingMessage !== '' && (
                <Message
                  model={{
                    type: 'html',
                    payload: cur_markup,
                    direction: 'incoming',
                    position: 0,
                    sender: 'BITE GPT',
                  }}
                />
              )}
            </>
          </MessageList>
          <MessageInput placeholder='Send a Message'
            attachButton={false}
            onSend={handleSendClick}
          />
        </ChatContainer>
      </MainContainer>
    </div>
  );
};
export default Chat2;
